import { c as _c } from "react/compiler-runtime";
// Third Party
import { AccountReviewSummary } from '@gql';

// UI
import googleReview from '../../../public/assets/svg/ratings/google-logo.svg';
import { RatingStars } from '@components/rating-stars';
import Image from 'next/image';
type Props = {
  reviewSummary: Pick<AccountReviewSummary, 'rating' | 'numberOfReviews'>;
};
export const GoogleRatingsDisplay: React.FC<Props> = t0 => {
  const $ = _c(13);
  const {
    reviewSummary
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="relative w-20 mb-2"><Image width={74} height={24} src={googleReview} className="w-full h-auto object-cover object-center" alt="Savvy google review" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = Number(reviewSummary.rating);
  let t3;
  if ($[1] !== t2) {
    t3 = t2.toFixed(2);
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <span className="text-alert-main text-sm font-bold">{t3}/{5}</span>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== reviewSummary.rating) {
    t5 = <span className="pl-1 flex flex-row"><RatingStars rating={reviewSummary.rating} /></span>;
    $[5] = reviewSummary.rating;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = reviewSummary.numberOfReviews || 1;
  let t7;
  if ($[7] !== t6) {
    t7 = <span className={"pl-8\n       text-sm font-bold z-20"}>({t6})</span>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t4 || $[10] !== t5 || $[11] !== t7) {
    t8 = <div>{t1}<div className="flex flex-row">{t4}{t5}{t7}</div></div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};